<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                      [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.tituloCardListar" [titulo]="DAT_TITULOS.titulo">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES LATERAL IZQUIERDO -->
    <ng-template #innTemplateButton>
        <div class="col-md-6">
            <div class="pagetitle">
                <div class="btn-group-justified btn-group" style="float: right;">
                    <a (click)="downloadDataCsv()" class="btn btn-outline-info"> <small class="fa fa-plus"></small> Descargar </a>
                </div>
                <div class="btn-group-justified btn-group" style="float: right;">
                    <a (click)="nuevo()" class="btn btn-outline-success"> <small class="fa fa-plus"></small> Nuevo </a>
                </div>
            </div>
        </div>
    </ng-template>
    <!-- OPCIONES LATERAL IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                       [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                       [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                       [pagination]="true"
                       [rowData]="rowData">
      </ag-grid-angular>
    </ng-template>
    <!-- GRILLA -->
  </div>


  <!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'"  [idButton]="'abrirModal'" [idClose]="'cerrarModal'"  [innTemplate]="abrirModal" [titulo]="tituloModal">
</app-lfsa-modal>

<ng-template #abrirModal>
    <div class="container-fluid">
        <form [formGroup]="FormConfigurar" mat-dialog-content>
            <div class="row">

                <div class="col-12 mb-3">
                    <strong>DATOS DEL SISTEMA</strong>
                    <div class="row py-2 border border-success rounded">
                        <div class="col-sm form-group">
                            <label for="paramId">* Configuración ID</label>
                            <input class="form-control" formControlName="paramId" id="paramId" type="text" readonly>
                        </div>
                        <div class="col-sm form-group">
                            <label for="fechaRegistro">* Fecha Registro</label>
                            <input class="form-control" formControlName="fechaRegistro" id="fechaRegistro" type="text" readonly>
                        </div>        
                        <div class="col-sm form-group">
                            <label for="usuario">* Usuario</label>
                            <input class="form-control" formControlName="usuario" id="usuario" type="text" readonly>
                        </div>
                        <div class="p-2"></div>
                    </div>
                </div>
        
                <div class="col-12 mb-3">
                    <strong>INFORMACION DEL MATRIAL - CPD</strong>
                    <div class="row py-2 border border-success rounded">
                        <div class="col-sm form-group">
                            <label for="nodo">* Seleccione Nodo</label>
                            <select class="form-control" formControlName="nodo" name="nodo">
                                <option value="">-- Seleccione --</option>
                                <option *ngFor="let registro of comboNodos" [value]="registro.nodo">{{registro.descripcionNodo}}</option>
                            </select>
                            <div class="text-danger" *ngIf="FormConfigurar.get('nodo')?.hasError('required')">
                                <small>El campo Nodo es requerido.</small>
                            </div>
                        </div>

                        <div class="col-sm form-group">
                            <label for="material">* Código Material</label>
                            <input class="form-control" formControlName="material" id="material" type="text" (change)="onChangeMaterial($event);" (keydown.space)="$event.preventDefault()" (paste)="onPasteMaterial($event)" minlength="5" maxlength="10" >
                            <div class="text-danger" *ngIf="FormConfigurar.get('material')?.hasError('required')">
                                <small>El campo material es requerido.</small>
                            </div>
                        </div> 

                        <div class="col-sm form-group">
                            <label for="descaMaterial">* Descrip. Material</label>
                            <input class="form-control" formControlName="descaMaterial" id="descaMaterial" type="text" readonly>
                        </div>  

                        <div class="col-sm form-group">
                            <label for="unidadBase">* Unidad Base</label>
                            <input class="form-control" formControlName="unidadBase" id="unidadBase" type="text" readonly>
                            <div class="text-danger" *ngIf="FormConfigurar.get('unidadBase')?.hasError('required')">
                                <small>El campo unidadBase es requerido.</small>
                            </div>
                        </div>

                        <div class="col-sm form-group">
                            <label for="unidadPT"> Unidad PT</label>
                            <input class="form-control" formControlName="unidadPT" id="unidadPT" type="text" readonly>
                        </div>

                        <div class="col-sm form-group">
                            <label for="cpd">* CPD</label>
                            <input class="form-control" formControlName="cpd" id="cpd" type="number">
                            <div class="text-danger" *ngIf="FormConfigurar.get('cpd')?.hasError('required')">
                                <small>El campo cpd es requerido.</small>
                            </div>
                        </div>
                        <div class="p-2"></div>
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <strong>VIGENCIA DEL CPD FORZADO</strong>
                    <div class="row py-2 border border-success rounded">
                        <div class="col-4">
                            <label for="fechaInicio">* Fecha Inicio</label>
                            <input class="form-control" formControlName="fechaInicio" id="fechaInicio" type="date">

                            <small *ngIf="FormConfigurar.get('fechaInicio')?.invalid && FormConfigurar.get('fechaInicio')?.touched" class="text-danger">
                                Campo obligatorio. No puede ser mayor que la Fecha Fin
                            </small>
                            <small class="text-danger" *ngIf="FormConfigurar.hasError('fechaInicioMayor')"> La fecha de inicio no puede ser mayor a la fecha de fin.</small>
                        </div>
        
                        <div class="col-4">
                            <label for="fechaFin">* Fecha Fin</label>
                            <input class="form-control" formControlName="fechaFin" id="fechaFin" type="date">

                            <small class="text-danger" *ngIf="FormConfigurar.get('fechaFin')?.hasError('required')" > Campo Obligatorio </small>
                            <small class="text-danger" *ngIf="FormConfigurar.hasError('fechaFinMenor')">La fecha fin no puede ser menor a la fecha de inicio.</small>
                        </div>

                        <div class="col-4 disabledSelect">
                            <label for="estado">* Estado</label>
                            <select [disabled]="true" class="form-control" formControlName="estado" name="estado" id="estado disabledSelect" readonly >
                                <option value="">-- Seleccione --</option>
                                <option *ngFor="let estado of comboEstado" [value]="estado.valor">{{estado.valor}}</option>
                            </select>
                        </div>
                        <div class="p-2"></div>
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <strong>ACTUALIZACIÓN DEL REGISTRO</strong>
                    <div class="row py-2 border border-success rounded">
                        <div class="col-sm form-group">
                            <label for="fechaUpdate">* Fecha Actualización</label>
                            <input class="form-control" formControlName="fechaUpdate" id="fechaUpdate" type="text" readonly>
                        </div>        
                        <div class="col-sm form-group">
                            <label for="usuarioUpdate">* Usuario actualización</label>
                            <input class="form-control" formControlName="usuarioUpdate" id="usuarioUpdate" type="text" readonly>
                        </div>
                        <div class="p-2"></div>
                    </div>
                </div>

                <!-- Ejecuta accion de nuevo y regresar -->
                <app-lfsa-botones-formulario
                    (devolverAccion)="acciones( $event )" [formularioValido]="FormConfigurar.invalid"
                    [loading]="loading" [textBoton]="'Guardar'" class="row mt-3">
                </app-lfsa-botones-formulario>

            </div>
        </form>
    </div>
</ng-template>
<!-- END MODAL -->
  